import { render, staticRenderFns } from "./SntSelectBank.vue?vue&type=template&id=2605a5f3&scoped=true&"
import script from "./SntSelectBank.vue?vue&type=script&lang=js&"
export * from "./SntSelectBank.vue?vue&type=script&lang=js&"
import style0 from "./SntSelectBank.vue?vue&type=style&index=0&id=2605a5f3&prod&lang=css&"
import style1 from "./SntSelectBank.vue?vue&type=style&index=1&id=2605a5f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605a5f3",
  null
  
)

export default component.exports